import {default as menu} from './menu.json'
import {default as isdrmenu} from './isdrmenu.json'
import {default as recentDreamsData} from './isdr/recentdreams.json'
export const menuJson = menu
export const isdrmenuJson = isdrmenu
export const recentDreams = recentDreamsData
